import { isDarkTheme } from '@/constants/Colors';
import { getCatalogPalette } from '@/components/Catalog/catalogPalette';

const light = {
  blue: '#4776B8',
  red: '#BE5C51',
  green: '#487D61',
  orange: '#B8793F',
  purple: '#8665AD',
};

const dark = {
  blue: '#91B5EB',
  red: '#EAA096',
  green: '#9AC5AA',
  orange: '#E3B17E',
  purple: '#BBA5DB',
};

const palettes = new Map();
export const getLibraryPalette = theme => {
  const catalog = getCatalogPalette(theme);
  if (!palettes.has(catalog)) {
    palettes.set(catalog, {
      ...(isDarkTheme(theme) ? dark : light),
      ...catalog,
      paper: catalog.control,
    });
  }
  return palettes.get(catalog);
};
